import { lazy } from "react";
// import { Suspense } from "react";
import { Navigate } from "react-router-dom";

// Dashboard (Lazy Loaded)
// const DashboardAnalytics = lazy(() =>
//   import("../pages/DashboardAnalytics")
// );

// const DashboardCrm = lazy(() =>
//   import("../pages/DashboardCrm")
// );

const DashboardEcommerce = lazy(() =>
  import("../pages/DashboardEcommerce")
);

// const DashboardCrypto = lazy(() =>
//   import("../pages/DashboardCrypto")
// );

// const DashboardProject = lazy(() =>
//   import("../pages/DashboardProject")
// );

// const DashboardNFT = lazy(() =>
//   import("../pages/DashboardNFT")
// );

// const DashboardJob = lazy(() =>
//   import("../pages/DashboardJob")
// );


// // Calendar
// const Calendar = lazy(() => import("../pages/Calendar/Maincalender"));
// const MonthGrid = lazy(() => import("../pages/Calendar/MonthGrid"));

// // Email Box
// const MailInbox = lazy(() => import("../pages/EmailInbox"));
// const BasicAction = lazy(() => import("../pages/Email/EmailTemplates/BasicAction"));
// const EcommerceAction = lazy(() => import("../pages/Email/EmailTemplates/EcommerceAction"));

// // Chat
// const Chat = lazy(() => import("../pages/Chat"));

// // Project
// const ProjectList = lazy(() => import("../pages/Projects/ProjectList"));
// const ProjectOverview = lazy(() => import("../pages/Projects/ProjectOverview"));
// const CreateProject = lazy(() => import("../pages/Projects/CreateProject"));


// // Task
// const TaskDetails = lazy(() => import("../pages/Tasks/TaskDetails"));
// const TaskList = lazy(() => import("../pages/Tasks/TaskList"));
// const Kanbanboard = lazy(() => import("../pages/Tasks/KanbanBoard"));

// // Transactions (Crypto)
// const Transactions = lazy(() => import("../pages/Crypto/Transactions"));
// const BuySell = lazy(() => import("../pages/Crypto/BuySell"));
// const CryproOrder = lazy(() => import("../pages/Crypto/CryptoOrder"));
// const MyWallet = lazy(() => import("../pages/Crypto/MyWallet"));
// const ICOList = lazy(() => import("../pages/Crypto/ICOList"));
// const KYCVerification = lazy(() => import("../pages/Crypto/KYCVerification"));

// CRM Pages
// const CrmCompanies = lazy(() => import("../pages/Crm/CrmCompanies"));
// const CrmContacts = lazy(() => import("../pages/Crm/CrmContacts"));
// const CrmDeals = lazy(() => import("../pages/Crm/CrmDeals/index"));
// const CrmLeads = lazy(() => import("../pages/Crm/CrmLeads/index"));


// // Invoices
// const InvoiceList = lazy(() => import("../pages/Invoices/InvoiceList"));
// const InvoiceCreate = lazy(() => import("../pages/Invoices/InvoiceCreate"));
// const InvoiceDetails = lazy(() => import("../pages/Invoices/InvoiceDetails"));

// // Support Tickets
// const ListView = lazy(() => import("../pages/SupportTickets/ListView"));
// const TicketsDetails = lazy(() => import("../pages/SupportTickets/TicketsDetails"));

// Ecommerce Pages
// const EcommerceProducts = lazy(() => import("../pages/Ecommerce/EcommerceProducts/index"));
// const EcommerceProductDetail = lazy(() => import("../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail"));
// const EcommerceAddProduct = lazy(() => import("../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct"));
// const EcommerceOrders = lazy(() => import("../pages/Ecommerce/EcommerceOrders/index"));
// const EcommerceOrderDetail = lazy(() => import("../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail"));
// const EcommerceCustomers = lazy(() => import("../pages/Ecommerce/EcommerceCustomers/index"));
// const EcommerceCart = lazy(() => import("../pages/Ecommerce/EcommerceCart"));
// const EcommerceCheckout = lazy(() => import("../pages/Ecommerce/EcommerceCheckout"));
// const EcommerceSellers = lazy(() => import("../pages/Ecommerce/EcommerceSellers/index"));
// const EcommerceSellerDetail = lazy(() => import("../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail"));

// const Marketplace = lazy(() => import("../pages/NFTMarketplace/Marketplace"));
// const Collections = lazy(() => import("../pages/NFTMarketplace/Collections"));
// const CreateNFT = lazy(() => import("../pages/NFTMarketplace/CreateNFT"));
// const Creators = lazy(() => import("../pages/NFTMarketplace/Creators"));
// const ExploreNow = lazy(() => import("../pages/NFTMarketplace/ExploreNow"));
// const ItemDetails = lazy(() => import("../pages/NFTMarketplace/Itemdetails"));
// const LiveAuction = lazy(() => import("../pages/NFTMarketplace/LiveAuction"));
// const Ranking = lazy(() => import("../pages/NFTMarketplace/Ranking"));
// const WalletConnect = lazy(() => import("../pages/NFTMarketplace/WalletConnect"));

// // Base Ui
// const UiAlerts = lazy(() => import("../pages/BaseUi/UiAlerts/UiAlerts"));
// const UiBadges = lazy(() => import("../pages/BaseUi/UiBadges/UiBadges"));
// const UiButtons = lazy(() => import("../pages/BaseUi/UiButtons/UiButtons"));
// const UiColors = lazy(() => import("../pages/BaseUi/UiColors/UiColors"));
// const UiCards = lazy(() => import("../pages/BaseUi/UiCards/UiCards"));
// const UiCarousel = lazy(() => import("../pages/BaseUi/UiCarousel/UiCarousel"));
// const UiDropdowns = lazy(() => import("../pages/BaseUi/UiDropdowns/UiDropdowns"));
// const UiGrid = lazy(() => import("../pages/BaseUi/UiGrid/UiGrid"));
// const UiImages = lazy(() => import("../pages/BaseUi/UiImages/UiImages"));
// const UiTabs = lazy(() => import("../pages/BaseUi/UiTabs/UiTabs"));
// const UiAccordions = lazy(() => import("../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse"));
// const UiModals = lazy(() => import("../pages/BaseUi/UiModals/UiModals"));
// const UiOffcanvas = lazy(() => import("../pages/BaseUi/UiOffcanvas/UiOffcanvas"));
// const UiPlaceholders = lazy(() => import("../pages/BaseUi/UiPlaceholders/UiPlaceholders"));
// const UiProgress = lazy(() => import("../pages/BaseUi/UiProgress/UiProgress"));
// const UiNotifications = lazy(() => import("../pages/BaseUi/UiNotifications/UiNotifications"));
// const UiMediaobject = lazy(() => import("../pages/BaseUi/UiMediaobject/UiMediaobject"));
// const UiEmbedVideo = lazy(() => import("../pages/BaseUi/UiEmbedVideo/UiEmbedVideo"));
// const UiTypography = lazy(() => import("../pages/BaseUi/UiTypography/UiTypography"));
// const UiList = lazy(() => import("../pages/BaseUi/UiLists/UiLists"));
// const UiGeneral = lazy(() => import("../pages/BaseUi/UiGeneral/UiGeneral"));
// const UiRibbons = lazy(() => import("../pages/BaseUi/UiRibbons/UiRibbons"));
// const UiUtilities = lazy(() => import("../pages/BaseUi/UiUtilities/UiUtilities"));

// Advance Ui
// const UiNestableList = lazy(() => import("../pages/AdvanceUi/UiNestableList/UiNestableList"));
// const UiScrollbar = lazy(() => import("../pages/AdvanceUi/UiScrollbar/UiScrollbar"));
// const UiAnimation = lazy(() => import("../pages/AdvanceUi/UiAnimation/UiAnimation"));
// const UiSwiperSlider = lazy(() => import("../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider"));
// const UiRatings = lazy(() => import("../pages/AdvanceUi/UiRatings/UiRatings"));
// const UiHighlight = lazy(() => import("../pages/AdvanceUi/UiHighlight/UiHighlight"));


// Widgets
const Widgets = lazy(() => import('../pages/Widgets/Index'));

// Forms
// const BasicElements = lazy(() => import("../pages/Forms/BasicElements/BasicElements"));
// const FormSelect = lazy(() => import("../pages/Forms/FormSelect/FormSelect"));
// const FormEditor = lazy(() => import("../pages/Forms/FormEditor/FormEditor"));
// const CheckBoxAndRadio = lazy(() => import("../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio"));
// const Masks = lazy(() => import("../pages/Forms/Masks/Masks"));
// const FileUpload = lazy(() => import("../pages/Forms/FileUpload/FileUpload"));
// const FormPickers = lazy(() => import("../pages/Forms/FormPickers/FormPickers"));
// const FormRangeSlider = lazy(() => import("../pages/Forms/FormRangeSlider/FormRangeSlider"));
// const Formlayouts = lazy(() => import("../pages/Forms/FormLayouts/Formlayouts"));
// const FormValidation = lazy(() => import("../pages/Forms/FormValidation/FormValidation"));
// const FormWizard = lazy(() => import("../pages/Forms/FormWizard/FormWizard"));
// const FormAdvanced = lazy(() => import("../pages/Forms/FormAdvanced/FormAdvanced"));
// const Select2 = lazy(() => import("../pages/Forms/Select2/Select2"));

// Tables
// const BasicTables = lazy(() => import('../pages/Tables/BasicTables/BasicTables'));
// const ListTables = lazy(() => import('../pages/Tables/ListTables/ListTables'));
// const ReactTable = lazy(() => import("../pages/Tables/ReactTables"));

// // Icon pages
// const RemixIcons = lazy(() => import("../pages/Icons/RemixIcons/RemixIcons"));
// const BoxIcons = lazy(() => import("../pages/Icons/BoxIcons/BoxIcons"));
// const MaterialDesign = lazy(() => import("../pages/Icons/MaterialDesign/MaterialDesign"));
// const FeatherIcons = lazy(() => import("../pages/Icons/FeatherIcons/FeatherIcons"));
// const LineAwesomeIcons = lazy(() => import("../pages/Icons/LineAwesomeIcons/LineAwesomeIcons"));
// const CryptoIcons = lazy(() => import("../pages/Icons/CryptoIcons/CryptoIcons"));

// Maps
const GoogleMaps = lazy(() => import("../pages/Maps/GoogleMaps/GoogleMaps"));

// Authentication Inner Pages
const BasicSignIn = lazy(() => import('../pages/AuthenticationInner/Login/BasicSignIn'));
const CoverSignIn = lazy(() => import('../pages/AuthenticationInner/Login/CoverSignIn'));
const BasicSignUp = lazy(() => import('../pages/AuthenticationInner/Register/BasicSignUp'));
const CoverSignUp = lazy(() => import("../pages/AuthenticationInner/Register/CoverSignUp"));
const BasicPasswReset = lazy(() => import('../pages/AuthenticationInner/PasswordReset/BasicPasswReset'));
const CoverPasswReset = lazy(() => import('../pages/AuthenticationInner/PasswordReset/CoverPasswReset'));
const BasicLockScreen = lazy(() => import('../pages/AuthenticationInner/LockScreen/BasicLockScr'));
const CoverLockScreen = lazy(() => import('../pages/AuthenticationInner/LockScreen/CoverLockScr'));
const BasicLogout = lazy(() => import('../pages/AuthenticationInner/Logout/BasicLogout'));
const CoverLogout = lazy(() => import('../pages/AuthenticationInner/Logout/CoverLogout'));
const BasicSuccessMsg = lazy(() => import('../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg'));
const CoverSuccessMsg = lazy(() => import('../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg'));
const BasicTwosVerify = lazy(() => import('../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify'));
const CoverTwosVerify = lazy(() => import('../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify'));
const Basic404 = lazy(() => import('../pages/AuthenticationInner/Errors/Basic404'));
const Cover404 = lazy(() => import('../pages/AuthenticationInner/Errors/Cover404'));
const Alt404 = lazy(() => import('../pages/AuthenticationInner/Errors/Alt404'));
const Error500 = lazy(() => import('../pages/AuthenticationInner/Errors/Error500'));
const BasicPasswCreate = lazy(() => import("../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate"));
const CoverPasswCreate = lazy(() => import("../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate"));
const Offlinepage = lazy(() => import("../pages/AuthenticationInner/Errors/Offlinepage"));

// API Key
// const APIKey = lazy(() => import("../pages/APIKey/index"));

// Authentication Pages
const Login = lazy(() => import("../pages/Authentication/Login"));
const ForgetPasswordPage = lazy(() => import("../pages/Authentication/ForgetPassword"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Register = lazy(() => import("../pages/Authentication/Register"));

// Charts
// const LineCharts = lazy(() => import("../pages/Charts/ApexCharts/LineCharts"));
// const AreaCharts = lazy(() => import("../pages/Charts/ApexCharts/AreaCharts"));
// const ColumnCharts = lazy(() => import("../pages/Charts/ApexCharts/ColumnCharts"));
// const BarCharts = lazy(() => import("../pages/Charts/ApexCharts/BarCharts"));
// const MixedCharts = lazy(() => import("../pages/Charts/ApexCharts/MixedCharts"));
// const TimelineCharts = lazy(() => import("../pages/Charts/ApexCharts/TimelineCharts"));
// const CandlestickChart = lazy(() => import("../pages/Charts/ApexCharts/CandlestickChart"));
// const BoxplotCharts = lazy(() => import("../pages/Charts/ApexCharts/BoxplotCharts"));
// const BubbleChart = lazy(() => import("../pages/Charts/ApexCharts/BubbleChart"));
// const ScatterCharts = lazy(() => import("../pages/Charts/ApexCharts/ScatterCharts"));
// const HeatmapCharts = lazy(() => import("../pages/Charts/ApexCharts/HeatmapCharts"));
// const TreemapCharts = lazy(() => import("../pages/Charts/ApexCharts/TreemapCharts"));
// const PieCharts = lazy(() => import("../pages/Charts/ApexCharts/PieCharts"));
// const RadialbarCharts = lazy(() => import("../pages/Charts/ApexCharts/RadialbarCharts"));
// const RadarCharts = lazy(() => import("../pages/Charts/ApexCharts/RadarCharts"));
// const PolarCharts = lazy(() => import("../pages/Charts/ApexCharts/PolarCharts"));
// const ChartsJs = lazy(() => import("../pages/Charts/ChartsJs/index"));
// const Echarts = lazy(() => import("../pages/Charts/ECharts/index"));

// Job Pages
// const Statistics = lazy(() => import("../pages/Jobs/Statistics"));
// const JobList = lazy(() => import("../pages/Jobs/JobList/List"));
// const JobGrid = lazy(() => import("../pages/Jobs/JobList/Grid"));
// const JobOverview = lazy(() => import("../pages/Jobs/JobList/Overview"));
// const CandidateList = lazy(() => import("../pages/Jobs/CandidateList/ListView"));
// const CandidateGrid = lazy(() => import("../pages/Jobs/CandidateList/GridView"));
// const NewJobs = lazy(() => import("../pages/Jobs/NewJob"));
// const JobCategories = lazy(() => import("../pages/Jobs/JobCategories"));
// const Application = lazy(() => import("../pages/Jobs/Application"));
// const CompaniesList = lazy(() => import("../pages/Jobs/CompaniesList"));

// Landing Pages
const OnePage = lazy(() => import("../pages/Landing/OnePage"));
const NFTLanding = lazy(() => import("../pages/Landing/NFTLanding"));

// Pages
// const Starter = lazy(() => import('../pages/Pages/Starter/Starter'));
// const SimplePage = lazy(() => import('../pages/Pages/Profile/SimplePage/SimplePage'));
// const Settings = lazy(() => import('../pages/Pages/Profile/Settings/Settings'));
// const Team = lazy(() => import('../pages/Pages/Team/Team'));
// const Timeline = lazy(() => import('../pages/Pages/Timeline/Timeline'));
// const Faqs = lazy(() => import('../pages/Pages/Faqs/Faqs'));
// const Pricing = lazy(() => import('../pages/Pages/Pricing/Pricing'));
// const Gallery = lazy(() => import('../pages/Pages/Gallery/Gallery'));
const Maintenance = lazy(() => import('../pages/Pages/Maintenance/Maintenance'));
const ComingSoon = lazy(() => import('../pages/Pages/ComingSoon/ComingSoon'));
// const SiteMap = lazy(() => import('../pages/Pages/SiteMap/SiteMap'));
// const SearchResults = lazy(() => import('../pages/Pages/SearchResults/SearchResults'));
// const PrivecyPolicy = lazy(() => import('../pages/Pages/PrivacyPolicy'));
// const TermsCondition = lazy(() => import('../pages/Pages/TermsCondition'));
const JobLanding = lazy(() => import("../pages/Job_Landing/Job"));
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));

// Utilities / Others
// const FileManager = lazy(() => import("../pages/FileManager"));
// const ToDoList = lazy(() => import("../pages/ToDo"));
// const RangeArea = lazy(() => import("../pages/Charts/ApexCharts/RangeAreaCharts/Index"));
// const FunnelChart = lazy(() => import("../pages/Charts/ApexCharts/FunnelCharts/Index"));
// const UiLink = lazy(() => import("../pages/BaseUi/UiLinks/UiLinks"));
// const DashboardBlog = lazy(() => import("../pages/DashboardBlog"));
// const SlopeCharts = lazy(() => import("../pages/Charts/ApexCharts/SlopeCharts"));
// const BlogListView = lazy(() => import("../pages/Pages/Blogs/ListView"));
// const BlogGridView = lazy(() => import("../pages/Pages/Blogs/GridView"));
// const PageBlogOverview = lazy(() => import("../pages/Pages/Blogs/Overview"));

// Account Pages
const RegisteredUser = lazy(() => import("../pages/Account/RegisteredUser"));
const RegisteredUserDetails = lazy(() => import("../pages/Account/RegisteredUserDetails"));
const Documents = lazy(() => import("../pages/Account/Documents"));
const AiAccessRequests = lazy(() => import("../pages/Account/AiAccessRequests"));
const LiveTradingAccounts = lazy(() => import("../pages/Account/LiveTradingAccounts"));
const AddnewUser = lazy(() => import("../pages/Account/AddnewUser"));
const MyntLiveTradingAccounts = lazy(() => import("../pages/Account/MyntLiveTradingAccounts"));
const LiveExposureSummary = lazy(() => import("../pages/Account/LiveExposureSummary"));
const AccountTransactionHistory = lazy(() => import("../pages/Account/AccountTransactionHistory"));

// Partners
const PartnerList = lazy(() => import("../pages/Partners/PartnerList"));
const Currency = lazy(() => import("../pages/Partners/Currency"));
const AssignAccType = lazy(() => import("../pages/Partners/AssignAccType"));
const CommissionSettings = lazy(() => import("../pages/Partners/CommissionSettings"));
// const WithdrawRequests = lazy(() => import("../pages/Partners/WithdrawRequests"));
const PartnerDetails = lazy(() => import("../pages/Partners/PartnerDetails"));

// Payments
const DepositPayment = lazy(() => import("../pages/Payments/DepositPayment"));
const WithdrawPayment = lazy(() => import("../pages/Payments/WithdrawPayment"));
const DepositRequest = lazy(() => import("../pages/Payments/DepositRequest"));
const WithdrawRequest = lazy(() => import("../pages/Payments/WithdrawRequest"));
const DepositRequestMT5 = lazy(() => import("../pages/Payments/DepositRequestMT5"));
const WithdrawRequestMT5 = lazy(() => import("../pages/Payments/WithdrawRequestMT5"));

// Transactions
const TrxHistory = lazy(() => import("../pages/Transactions/TrxHistory"));
const Deposit = lazy(() => import("../pages/Transactions/Deposit"));
const Withdraw = lazy(() => import("../pages/Transactions/Withdraw"));
const InternalTransfer = lazy(() => import("../pages/Transactions/InternalTransfer"));
const CreditIn = lazy(() => import("../pages/Transactions/CreditIn"));
const CreditOut = lazy(() => import("../pages/Transactions/CreditOut"));

// MAM
const Managers = lazy(() => import("../pages/MAM/Managers"));
const Investors = lazy(() => import("../pages/MAM/Investors"));
const ManagerCommissionHistory = lazy(() => import("../pages/MAM/ManagerCommissionHistory"));

// Trades
const LiveTrades = lazy(() => import("../pages/Trades/LiveTrades"));
const ClosedTrades = lazy(() => import("../pages/Trades/ClosedTrades"));
const ShortDurationTrades = lazy(() => import("../pages/Trades/ShortDurationTrades"));
const BookManagement = lazy(() => import("../pages/Trades/BookManagement"));
const BookManagementMT5 = lazy(() => import("../pages/Trades/BookManagementMT5"));
const OrderSummary = lazy(() => import("../pages/Trades/OrderSummary"));
const DemoStaleOrders = lazy(() => import("../pages/Trades/DemoStaleOrders"));
const MT5WinnersLosers = lazy(() => import("../pages/Trades/MT5WinnersLosers"));
const MyntWinnersLosers = lazy(() => import("../pages/Trades/MyntWinnersLosers"));

// MT5
const MT5Orders = lazy(() => import("../pages/MT5/MT5Orders"));

// MYNT
const MyntClosedOrders = lazy(() => import("../pages/Account/MyntClosedOrders"));
const MyntAccountEarnings = lazy(() => import("../pages/Account/MyntAccountEarnings"));

// Apps
const AppVersion = lazy(() => import("../pages/Apps/AppVersion"));
const SendNotification = lazy(() => import("../pages/Apps/SendNotification"));
const AddBanner = lazy(() => import("../pages/Apps/AddBanner"));

//commented to use it in future development
const Coupons = lazy(() => import("../pages/Apps/Coupons"));

// Setting
const Leverage = lazy(() => import("../pages/Setting/Leverage"));
const AccGroupsAndLimits = lazy(() => import("../pages/Setting/AccGroupsAndLimits"));
const PaymentMethods = lazy(() => import("../pages/Setting/PaymentMethods"));
const DepositWithdrawConversion = lazy(() => import("../pages/Setting/DepositWithdrawConversion"));
const CountryConfig = lazy(() => import("../pages/Setting/CountryConfig"));

// Admins
const AdminList = lazy(() => import("../pages/Admins/AdminList"));
const LoginRecords = lazy(() => import("../pages/Admins/LoginRecords"));

// Reports
const DepositsReport = lazy(() => import("../pages/Reports/DepositsReport"));
const WithdrawReport = lazy(() => import("../pages/Reports/WithdrawReport"));
const DepositsReportMt5 = lazy(() => import("../pages/Reports/DepositsReportMt5"));
const WithdrawReportMt5 = lazy(() => import("../pages/Reports/WithdrawReportMt5"));
const ClosedOrdersReport = lazy(() => import("../pages/Reports/ClosedOrdersReport"));


const authProtectedRoutes = [
  // { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  // { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },
  // { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  // { path: "/dashboard-projects", component: <DashboardProject /> },
  // { path: "/dashboard-nft", component: <DashboardNFT /> },
  // { path: "/dashboard-job", component: <DashboardJob /> },
  // { path: "/dashboard-blog", component: <DashboardBlog /> },

  // { path: "/apps-calendar", component: <Calendar /> },
  // { path: "/apps-calendar-month-grid", component: <MonthGrid /> },
  // { path: "/apps-ecommerce-products", component: <EcommerceProducts /> },
  // { path: "/apps-ecommerce-product-details/:_id", component: <EcommerceProductDetail /> },
  // { path: "/apps-ecommerce-product-details", component: <EcommerceProductDetail /> },
  // { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct /> },
  // { path: "/apps-ecommerce-orders", component: <EcommerceOrders /> },
  // { path: "/apps-ecommerce-order-details", component: <EcommerceOrderDetail /> },
  // { path: "/apps-ecommerce-customers", component: <EcommerceCustomers /> },
  // { path: "/apps-ecommerce-cart", component: <EcommerceCart /> },
  // { path: "/apps-ecommerce-checkout", component: <EcommerceCheckout /> },
  // { path: "/apps-ecommerce-sellers", component: <EcommerceSellers /> },
  // { path: "/apps-ecommerce-seller-details", component: <EcommerceSellerDetail /> },

  // { path: "/apps-file-manager", component: <FileManager /> },
  // { path: "/apps-todo", component: <ToDoList /> },


  // //Chat
  // { path: "/apps-chat", component: <Chat /> },

  // //EMail
  // { path: "/apps-mailbox", component: <MailInbox /> },
  // { path: "/apps-email-basic", component: <BasicAction /> },
  // { path: "/apps-email-ecommerce", component: <EcommerceAction /> },

  // //Projects
  // { path: "/apps-projects-list", component: <ProjectList /> },
  // { path: "/apps-projects-overview", component: <ProjectOverview /> },
  // { path: "/apps-projects-create", component: <CreateProject /> },

  // //Task
  // { path: "/apps-tasks-list-view", component: <TaskList /> },
  // { path: "/apps-tasks-details", component: <TaskDetails /> },
  // { path: "/apps-tasks-kanban", component: <Kanbanboard /> },

  //Api Key
  // { path: "/apps-api-key", component: <APIKey /> },

  //Crm
  // { path: "/apps-crm-contacts", component: <CrmContacts /> },
  // { path: "/apps-crm-companies", component: <CrmCompanies /> },
  // { path: "/apps-crm-deals", component: <CrmDeals /> },
  // { path: "/apps-crm-leads", component: <CrmLeads /> },

  //Invoices
  // { path: "/apps-invoices-list", component: <InvoiceList /> },
  // { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  // { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  //Supports Tickets
  // { path: "/apps-tickets-list", component: <ListView /> },
  // { path: "/apps-tickets-details", component: <TicketsDetails /> },

  //transactions
  // { path: "/apps-crypto-transactions", component: <Transactions /> },
  // { path: "/apps-crypto-buy-sell", component: <BuySell /> },
  // { path: "/apps-crypto-orders", component: <CryproOrder /> },
  // { path: "/apps-crypto-wallet", component: <MyWallet /> },
  // { path: "/apps-crypto-ico", component: <ICOList /> },
  // { path: "/apps-crypto-kyc", component: <KYCVerification /> },

  // NFT Marketplace
  // { path: "/apps-nft-marketplace", component: <Marketplace /> },
  // { path: "/apps-nft-collections", component: <Collections /> },
  // { path: "/apps-nft-create", component: <CreateNFT /> },
  // { path: "/apps-nft-creators", component: <Creators /> },
  // { path: "/apps-nft-explore", component: <ExploreNow /> },
  // { path: "/apps-nft-item-details", component: <ItemDetails /> },
  // { path: "/apps-nft-auction", component: <LiveAuction /> },
  // { path: "/apps-nft-ranking", component: <Ranking /> },
  // { path: "/apps-nft-wallet", component: <WalletConnect /> },

  //charts
  // { path: "/charts-apex-line", component: <LineCharts /> },
  // { path: "/charts-apex-area", component: <AreaCharts /> },
  // { path: "/charts-apex-column", component: <ColumnCharts /> },
  // { path: "/charts-apex-bar", component: <BarCharts /> },
  // { path: "/charts-apex-mixed", component: <MixedCharts /> },
  // { path: "/charts-apex-timeline", component: <TimelineCharts /> },
  // { path: "/charts-apex-range-area", component: <RangeArea /> },
  // { path: "/charts-apex-funnel", component: <FunnelChart /> },
  // { path: "/charts-apex-candlestick", component: <CandlestickChart /> },
  // { path: "/charts-apex-boxplot", component: <BoxplotCharts /> },
  // { path: "/charts-apex-bubble", component: <BubbleChart /> },
  // { path: "/charts-apex-scatter", component: <ScatterCharts /> },
  // { path: "/charts-apex-heatmap", component: <HeatmapCharts /> },
  // { path: "/charts-apex-treemap", component: <TreemapCharts /> },
  // { path: "/charts-apex-pie", component: <PieCharts /> },
  // { path: "/charts-apex-radialbar", component: <RadialbarCharts /> },
  // { path: "/charts-apex-radar", component: <RadarCharts /> },
  // { path: "/charts-apex-polar", component: <PolarCharts /> },
  // { path: "/charts-apex-slope", component: <SlopeCharts /> },

  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-echarts", component: <Echarts /> },


  // Base Ui
  // { path: "/ui-alerts", component: <UiAlerts /> },
  // { path: "/ui-badges", component: <UiBadges /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-colors", component: <UiColors /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdowns /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-tabs", component: <UiTabs /> },
  // { path: "/ui-accordions", component: <UiAccordions /> },
  // { path: "/ui-modals", component: <UiModals /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  // { path: "/ui-placeholders", component: <UiPlaceholders /> },
  // { path: "/ui-progress", component: <UiProgress /> },
  // { path: "/ui-notifications", component: <UiNotifications /> },
  // { path: "/ui-media", component: <UiMediaobject /> },
  // { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-lists", component: <UiList /> },
  // { path: "/ui-links", component: <UiLink /> },
  // { path: "/ui-general", component: <UiGeneral /> },
  // { path: "/ui-ribbons", component: <UiRibbons /> },
  // { path: "/ui-utilities", component: <UiUtilities /> },

  // Advance Ui
  // { path: "/advance-ui-nestable", component: <UiNestableList /> },
  // { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  // { path: "/advance-ui-animation", component: <UiAnimation /> },
  // { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  // { path: "/advance-ui-ratings", component: <UiRatings /> },
  // { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // Widgets
  { path: "/widgets", component: <Widgets /> },

  // Forms
  // { path: "/forms-elements", component: <BasicElements /> },
  // { path: "/forms-select", component: <FormSelect /> },
  // { path: "/forms-editors", component: <FormEditor /> },
  // { path: "/forms-checkboxes-radios", component: <CheckBoxAndRadio /> },
  // { path: "/forms-masks", component: <Masks /> },
  // { path: "/forms-file-uploads", component: <FileUpload /> },
  // { path: "/forms-pickers", component: <FormPickers /> },
  // { path: "/forms-range-sliders", component: <FormRangeSlider /> },
  // { path: "/forms-layouts", component: <Formlayouts /> },
  // { path: "/forms-validation", component: <FormValidation /> },
  // { path: "/forms-wizard", component: <FormWizard /> },
  // { path: "/forms-advanced", component: <FormAdvanced /> },
  // { path: "/forms-select2", component: <Select2 /> },

  //Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-listjs", component: <ListTables /> },
  // { path: "/tables-react", component: <ReactTable /> },

  //Icons
  // { path: "/icons-remix", component: <RemixIcons /> },
  // { path: "/icons-boxicons", component: <BoxIcons /> },
  // { path: "/icons-materialdesign", component: <MaterialDesign /> },
  // { path: "/icons-feather", component: <FeatherIcons /> },
  // { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  // { path: "/icons-crypto", component: <CryptoIcons /> },

  //Maps
  { path: "/maps-google", component: <GoogleMaps /> },

  //Pages
  // { path: "/pages-starter", component: <Starter /> },
  // { path: "/pages-profile", component: <SimplePage /> },
  // { path: "/pages-profile-settings", component: <Settings /> },
  // { path: "/pages-team", component: <Team /> },
  // { path: "/pages-timeline", component: <Timeline /> },
  // { path: "/pages-faqs", component: <Faqs /> },
  // { path: "/pages-gallery", component: <Gallery /> },
  // { path: "/pages-pricing", component: <Pricing /> },
  // { path: "/pages-sitemap", component: <SiteMap /> },
  // { path: "/pages-search-results", component: <SearchResults /> },
  // { path: "/pages-privacy-policy", component: <PrivecyPolicy /> },
  // { path: "/pages-terms-condition", component: <TermsCondition /> },
  // { path: "/pages-blog-list", component: <BlogListView /> },
  // { path: "/pages-blog-grid", component: <BlogGridView /> },
  // { path: "/pages-blog-overview", component: <PageBlogOverview /> },

  //Job pages
  // { path: "/apps-job-statistics", component: <Statistics /> },
  // { path: "/apps-job-lists", component: <JobList /> },
  // { path: "/apps-job-grid-lists", component: <JobGrid /> },
  // { path: "/apps-job-details", component: <JobOverview /> },
  // { path: "/apps-job-candidate-lists", component: <CandidateList /> },
  // { path: "/apps-job-candidate-grid", component: <CandidateGrid /> },
  // { path: "/apps-job-application", component: <Application /> },
  // { path: "/apps-job-new", component: <NewJobs /> },
  // { path: "/apps-job-companies-lists", component: <CompaniesList /> },
  // { path: "/apps-job-categories", component: <JobCategories /> },



  //User Profile
  { path: "/profile", component: <UserProfile /> },

  //Account
  { path: "/add-user", component: <AddnewUser /> },
  { path: "/account-registered-user", component: <RegisteredUser /> },
  { path: "/registered-user-details/:id", component: <RegisteredUserDetails /> },
  { path: "/account-kyc", component: <Documents /> },
  { path: "/account-ai-access-requests", component: <AiAccessRequests /> },
  { path: "/account-live-trading", component: <LiveTrades /> },
  { path: "/mynt-live-trading-accounts", component: <MyntLiveTradingAccounts /> },
  { path: "/account-live-exposure", component: <LiveExposureSummary /> },

  //Partners
  { path: "/partners-list", component: <PartnerList /> },
  { path: "/partners-currency", component: <Currency /> },
  { path: "/partners-assign-acc-type", component: <AssignAccType /> },
  { path: "/partners-commission-settings", component: <CommissionSettings /> },
  // { path: "/partners-withdraw-requests", component: <WithdrawRequests /> },
  { path: "/partner-details/:userId", component: <PartnerDetails /> },

  //Transactions
  { path: "/transactions-history", component: <TrxHistory /> },
  { path: "/transactions-deposit", component: <Deposit /> },
  { path: "/transactions-withdraw", component: <Withdraw /> },
  { path: "/transactions-internal-transfer", component: <InternalTransfer /> },
  { path: "/transactions-credit-in", component: <CreditIn /> },
  { path: "/transactions-credit-out", component: <CreditOut /> },

  //MAM
  { path: "/mam-managers", component: <Managers /> },
  { path: "/mam-investors", component: <Investors /> },
  { path: "/mam-manager-commission-history", component: <ManagerCommissionHistory /> },

  //Trades
  { path: "/trades-live", component: <LiveTradingAccounts /> },
  { path: "/trades-closed", component: <ClosedTrades /> },
  { path: "/trades-short-duration", component: <ShortDurationTrades /> },
  { path: "/trades-book-management", component: <BookManagement /> },
  { path: "/trades-book-management-mt5", component: <BookManagementMT5 /> },
  { path: "/trades-order-summary", component: <OrderSummary /> },
  { path: "/trades-demo-stale-orders", component: <DemoStaleOrders /> },
  { path: "/trades-mt5-winners-losers", component: <MT5WinnersLosers /> },
  { path: "/trades-mynt-winners-losers", component: <MyntWinnersLosers /> },

  //MT5
  { path: "/mt5-orders", component: <MT5Orders /> },

  //MYNT
  { path: "/mynt-closed-orders", component: <MyntClosedOrders /> },
  { path: "/mynt-account-earnings", component: <MyntAccountEarnings /> },
  { path: "/account-transaction-history", component: <AccountTransactionHistory /> },

  // Apps
  { path: "/apps-app-version", component: <AppVersion /> },
  { path: "/apps-send-notification", component: <SendNotification /> },
  { path: "/apps-add-banner", component: <AddBanner /> },
  //commented to use it in future development
  { path: "/apps-coupons", component: <Coupons /> },

  //Payments
  { path: "/payments-deposit-payment", component: <DepositPayment /> },
  { path: "/payments-withdraw-payment", component: <WithdrawPayment /> },
  { path: "/payments-deposit-request", component: <DepositRequest /> },
  { path: "/payments-withdraw-request", component: <WithdrawRequest /> },
  { path: "/payments-deposit-request-mt5", component: <DepositRequestMT5 /> },
  { path: "/payments-withdraw-request-mt5", component: <WithdrawRequestMT5 /> },

  //Setting
  { path: "/setting-leverage", component: <Leverage /> },
  { path: "/setting-acc-groups-limits", component: <AccGroupsAndLimits /> },
  { path: "/setting-payment-methods", component: <PaymentMethods /> },
  { path: "/setting-deposit-withdraw-conversion", component: <DepositWithdrawConversion /> },
  { path: "/setting-country-config", component: <CountryConfig /> },

  //Admins
  { path: "/admins-list", component: <AdminList /> },
  { path: "/admins-login-records", component: <LoginRecords /> },

  //Reports
  { path: "/reports-deposits", component: <DepositsReport /> },
  { path: "/reports-withdraw", component: <WithdrawReport /> },
  { path: "/reports-deposits-mt5", component: <DepositsReportMt5 /> },
  { path: "/reports-withdraw-mt5", component: <WithdrawReportMt5 /> },
  { path: "/reports-closed-orders", component: <ClosedOrdersReport /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },

  { path: "/landing", component: <OnePage /> },
  { path: "/nft-landing", component: <NFTLanding /> },
  { path: "/job-landing", component: <JobLanding /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },

];

export { authProtectedRoutes, publicRoutes };